document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('variant:change', (event) => {
        const variant = event.detail.variant;
        if (!variant) return;

        let section = document.querySelector('#shopify-section-main-product');
        if (!section) {
            section = event.target.closest('.product-grid');
        }
        if (!section) return;

        // Get all thumbnails and slides
        const thumbnails = section.querySelectorAll('.product-thumbnail');
        const slides = section.querySelectorAll('.product-gallery__slide');

        // Show/hide thumbnails and slides based on variant ID
        // thumbnails.forEach(thumbnail => {
        //     const variantId = thumbnail.getAttribute('data-variant-id');
        //     thumbnail.classList.toggle('hidden', !String(variantId).split(',').includes(String(variant.id)));
        // });

        slides.forEach(slide => {
    const variantId = slide.getAttribute('data-variant-id');
    const isDefault = slide.classList.contains('default-variant-image');

    if (isDefault) {
        slide.classList.remove('hidden');
    } else {
        const shouldShow = String(variantId).split(',').includes(String(variant.id));
        slide.classList.toggle('hidden', !shouldShow);
    }
});

    });
});



document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.product-gallery__slide').forEach(slide => {
      const variantId = slide.getAttribute('data-variant-id');
      const mediaId = slide.getAttribute('data-media-id');

      if (variantId && mediaId && (variantId.includes(mediaId) || mediaId.includes(variantId))) {
        slide.classList.remove('hidden');
      }
    });
  });




                          